// extracted by mini-css-extract-plugin
module.exports = {"annexes-filter":"WithAnnexFilter_annexes-filter__3t9J9"};